// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"7d5a3bcd","129":"60a942e8","180":"c985e468","309":"60a942e8","392":"e3c85eb7","470":"f0296084","554":"528749a6","688":"5f8c1b98","765":"52c7c170","955":"18527105"}[chunkId] + ".chunk.css";
};